module.exports = "/images/steph.webp?48b785657f7e1fcb302a6c27e002a6a5";